import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SNACKBAR_DURATION_ERROR, SNACKBAR_DURATION_SUCCESS } from '../app.constants';

@Injectable({
	providedIn: 'root'
})
export class NotificationService {
	private snackBar = inject(MatSnackBar);

	openSnackbar(success: boolean, errorMessage?: string | null, action?: string): boolean {
		const close = $localize`:@@Close:Close`;
		if (!action) action = $localize`:@@Save:Save`;
		if (success) {
			this.snackBar.open(action + ' ' + $localize`:@@Successfully:successfully`, close, {
				duration: SNACKBAR_DURATION_SUCCESS,
				panelClass: ['snackbar-success']
			});
			return true;
		} else {
			const detail = errorMessage ? ': ' + errorMessage : '';
			this.snackBar.open(action + ' ' + $localize`:@@Failed:Failed` + detail, close, {
				duration: SNACKBAR_DURATION_ERROR,
				panelClass: ['snackbar-error']
			});
			return false;
		}
	}
}
